module.exports = __webpack_public_path__ + "img/flfgcolor.8dfe3b36.png";